import { produce } from "immer";
import { tSearchAction, tSearchState, tUpdateSearch } from "./types";

const defaultState = {
  rSearchData: {},
};

const handleUpdateSearchData = (state: tSearchState = defaultState, action: tUpdateSearch): tSearchState => {
  const { rSearchData = {} } = action;
  return { ...state, rSearchData };
};

export const SearchReducer = produce((state: tSearchState = defaultState, action: tSearchAction): tSearchState => {
  switch (action.type) {
    case "UPDATE_SEARCH":
      return handleUpdateSearchData(state, action);
    default:
      return state;
  }
});
